import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import NotificationBar from "../../../Parts/NotificationBar.jsx";
import SalesforceMapping from "../common/SalesforceMapping";
import SalesforceSettingComplete from "../common/SalesforceSettingComplete";
import SalesforceNotSupport from "../common/SalesforceNotSupport";
import SalesforceNotAuthorize from "../common/SalesforceNotAuthorize";
import SalesforceIntegrateExpire from "../common/SalesforceIntegrateExpire";
import SalesforceIntegrateLoading from "../common/SalesforceIntegrateLoading";
import SalesforceProgressBar from "../common/SalesforceProgressBar";
import ProgressControl from "../common/ProgressControl";
import TimelineStatusMappingTable from "./parts/TimelineStatusMappingTable";
import {
  salesforceTimelineStatusSettingStep,
  salesforceTimelineStatusSettingSteps,
  SalesforceExportMappingFrom,
  DialogType,
  SalesforceSettingDirectory,
  SalesforceTimelineStatusExportObjectType,
} from "../../../../constants/ComponentTypes";
import { makeSalesforceExportMap } from "../../../../utils/utils";

const { Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },
});

/**
 * タイムラインのSalesforce連携設定の編集
 */
class SalesforceTimelineStatusSettingEdit extends React.Component {
  state = {
    step: salesforceTimelineStatusSettingStep.MAPPING,
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceDescribeTimelineStatusExport();
    this.props.getSalesforceExportMappings({ type: SalesforceExportMappingFrom.TIMELINE_STATUS.value });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.successMessage === this.props.successMessage && this.props.successMessage && this.props.successMessage !== "") {
      this.displayNotification(this.props.successMessage, "success");
    } else if (prevProps.errorMessage !== this.props.errorMessage && this.props.errorMessage && this.props.errorMessage !== '') {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (prevProps.shortMessage !== this.props.shortMessage && this.props.shortMessage && this.props.shortMessage !== '') {
      this.displayNotification(this.props.shortMessage, "green");
    }

    // DBの値に上書きする
    if (prevProps.isLoadingMapping && !this.props.isLoadingMapping) {
      this.setState({
        mapping: makeSalesforceExportMap(this.props.mapping),
      });
    }
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToStep = (step) => {
    this.setState({ step: step });
  };

  goToSalesforceSettingHome = () => {
    this.props.goTo("/setting/integrations/salesforce");
  }

  handleUpdateMapping = (mapping) => {
    this.setState({
      mapping: mapping,
    });
  };

  handlePrev = () => {
    const goStep = this.state.step - 1;

    if (goStep < 0) {
      this.props.goBack();
    } else {
      this.goToStep(goStep);
    }
  };

  handleNext = () => {
    const goStep = this.state.step + 1;
    this.goToStep(goStep);
  };

  /*** render functions ***/
  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div
          style={{
            position: "fixed",
            zIndex: 10000,
            top: 10,
            width: "98%",
            left: "1%",
          }}
        >
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false });
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  render() {
    const { classes, isLoadingMapping, isLoadingFields } = this.props;

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle={SalesforceSettingDirectory.TIMELINE_STATUS.text + "連携設定"}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={this.goToSalesforceSettingHome}
        />
        <div className={classes.content}>
          {(() => {
            if (this.props.user) {
              if (!this.props.user.salesforce_integration_flag) {
                return <SalesforceNotSupport />;
              } else if (!this.props.user.integrations.salesforce) {
                return <SalesforceNotAuthorize />;
              } else if (this.props.expiredAccessError) {
                return <SalesforceIntegrateExpire />;
              } else if (isLoadingMapping || isLoadingFields) {
                return <SalesforceIntegrateLoading />;
              } else {
                switch (this.state.step) {
                  case salesforceTimelineStatusSettingStep.MAPPING:
                  case salesforceTimelineStatusSettingStep.PREVIEW:
                    return (
                      <div>
                        <SalesforceProgressBar
                          step={this.state.step}
                          steps={salesforceTimelineStatusSettingSteps}
                          goToSalesforceSettingHome={this.goToSalesforceSettingHome}
                        >
                          <SalesforceMapping
                            step={this.state.step}
                            salesforceSettingStep={salesforceTimelineStatusSettingStep}
                            salesforceSettingDirectory={SalesforceSettingDirectory.TIMELINE_STATUS}
                            sobjectName={SalesforceTimelineStatusExportObjectType.EVENT.text}
                          >
                            <TimelineStatusMappingTable
                              mapping={this.state.mapping}
                              enableEdit={this.state.step === salesforceTimelineStatusSettingStep.MAPPING ? true : false}
                              disabled={this.props.isConfiguring}
                              updateMapping={this.handleUpdateMapping}
                              eventFields={this.props.eventFields}
                            />
                          </SalesforceMapping>
                        </SalesforceProgressBar>
                        <ProgressControl
                          salesforceSettingDirectory={SalesforceSettingDirectory.TIMELINE_STATUS}
                          salesforceSettingStep={salesforceTimelineStatusSettingStep}
                          requiredFields={SalesforceSettingDirectory.TIMELINE_STATUS.required_fields.event}
                          step={this.state.step}
                          mapping={this.state.mapping}
                          isConfiguring={this.props.isConfiguring}
                          errorMessage={this.props.errorMessage}
                          postSalesforceExportMappingsTimelineStatus={this.props.postSalesforceExportMappingsTimelineStatus}
                          prev={this.handlePrev}
                          next={this.handleNext}
                        />
                      </div>
                    );
                  case salesforceTimelineStatusSettingStep.SETTING_COMPLETE:
                    return (
                      <SalesforceSettingComplete
                        type={SalesforceSettingDirectory.TIMELINE_STATUS.value}
                        dialogType={DialogType.EDIT}
                      />
                    );
                  default:
                    return null;
                }
              }
            }
          })()}
        </div>
        {this.renderNotification()}
      </Wrapper>
    );
  }
}

SalesforceTimelineStatusSettingEdit.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  // クライアントのSalesforce上のマッピング項目の候補をロード中かどうか
  isLoadingFields: PropTypes.bool.isRequired,
  eventFields: PropTypes.object,
  // DBに保存しているマッピングの情報ロード中かどうか
  isLoadingMapping: PropTypes.bool.isRequired,
  mapping: PropTypes.object,
  // DBにマッピング保存中かどうか
  isConfiguring: PropTypes.bool.isRequired,
  expiredAccessError: PropTypes.bool.isRequired,
  goTo: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  getSalesforceExportMappings: PropTypes.func.isRequired,
  getSalesforceDescribeTimelineStatusExport: PropTypes.func.isRequired,
  postSalesforceExportMappingsTimelineStatus: PropTypes.func.isRequired,
};

export default withStyles(styles)(SalesforceTimelineStatusSettingEdit);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/SalesforceTimelineStatusSettingEdit.jsx